<ion-header>
    <ion-toolbar>
        <ion-title> {{ 'Filters' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <form [formGroup]="form">
        <ion-list>

            <!-- Server -->
            <ion-item>
                <ion-label position="stacked"> {{ 'Server' | translate }}</ion-label>
                <ion-select formControlName="serverPlayerNumber" interface="popover">
                    <ion-select-option value="">{{ 'Any' | translate }}</ion-select-option>
                    <ion-select-option *ngFor="let p of getPlayers()" [value]="p.value">{{ p.name }}</ion-select-option>
                </ion-select>
            </ion-item>

            <!-- Serve location -->
            <ion-item>
                <ion-label position="stacked"> {{ 'Serve location' | translate }}</ion-label>
                <ion-select formControlName="serveLocation" interface="popover">
                    <ion-select-option value=""> {{ 'Any' | translate }}</ion-select-option>
                    <ion-select-option value="W"> {{ 'Wide' | translate }}</ion-select-option>
                    <ion-select-option value="M"> {{ 'Middle' | translate }}</ion-select-option>
                    <ion-select-option value="T"> {{ 'T' | translate }}</ion-select-option>
                </ion-select>
            </ion-item>

            <!-- Returning side -->
            <ion-item>
                <ion-label position="stacked"> {{ 'Returning side' | translate }}</ion-label>
                <ion-select formControlName="returningSide" interface="popover">
                    <ion-select-option value=""> {{ 'Any' | translate }}</ion-select-option>
                    <ion-select-option value="DEUCE"> {{ 'Deuce' | translate }}</ion-select-option>
                    <ion-select-option value="AD"> {{ 'Ad' | translate }}</ion-select-option>
                </ion-select>
            </ion-item>

            <!-- Rally length -->
            <ion-item>
                <ion-label position="stacked"> {{ 'Rally length' | translate }}</ion-label>
                <ion-select formControlName="rallyLength" interface="popover">
                    <ion-select-option value=""> {{ 'Any' | translate }}</ion-select-option>
                    <ion-select-option value="0-4"> {{ '0-4' | translate }}</ion-select-option>
                    <ion-select-option value="5-8"> {{ '5-8' | translate }}</ion-select-option>
                    <ion-select-option value="9+"> {{ '9+' | translate }}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-button class="ion-margin" (click)="dismiss()" expand="block">
                {{ 'Update' | translate }}
            </ion-button>
            <ion-button (click)="form.reset()" expand="block" fill="clear">
                {{ 'Clear' | translate }}
            </ion-button>
        </ion-list>
    </form>
</ion-content>